module.exports = __webpack_public_path__ + "img/pcp-logo.2f372e1.svg";